import { useEffect, useState } from "react";
import api from "../../lib/api";
import {
    LineChart,
    Line,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
    Cell,
} from "recharts";

function fmt(n) {
    return new Intl.NumberFormat("en-KE", { maximumFractionDigits: 0 }).format(n || 0);
}

const COLORS = ["#FF2D87", "#22D3EE", "#10B981", "#FBBF24", "#C026D3", "#0B1437", "#94A3B8", "#F472B6"];

export default function AnalyticsTab() {
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        api.get("/analytics/summary").then((r) => setSummary(r.data));
    }, []);

    return (
        <div className="space-y-6" data-testid="analytics-page">
            <div>
                <h2 className="font-display text-3xl font-extrabold text-onego-navy">Analytics</h2>
                <p className="text-slate-600">Track GMV, commission and product mix across your business.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                    { l: "GMV", v: summary?.gmv },
                    { l: "Commission", v: summary?.commission_earned },
                    { l: "Sales count", v: summary?.sales_count, raw: true },
                    { l: "Customers", v: summary?.customers_count, raw: true },
                ].map((s) => (
                    <div key={s.l} className="og-card p-5">
                        <p className="text-xs uppercase tracking-widest font-semibold text-slate-500">{s.l}</p>
                        <p className="mt-2 font-display text-3xl font-extrabold text-onego-navy">
                            {s.raw ? fmt(s.v) : `KES ${fmt(s.v)}`}
                        </p>
                    </div>
                ))}
            </div>

            <div className="og-card p-7">
                <h3 className="font-display text-xl font-bold text-onego-navy">Daily GMV (last 14 days)</h3>
                <div className="mt-4 h-72">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={summary?.daily || []}>
                            <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
                            <XAxis dataKey="date" stroke="#94a3b8" tickFormatter={(d) => d.slice(5)} />
                            <YAxis stroke="#94a3b8" />
                            <Tooltip />
                            <Line type="monotone" dataKey="amount" stroke="#FF2D87" strokeWidth={3} dot={{ r: 4, fill: "#FF2D87" }} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>

            <div className="og-card p-7">
                <h3 className="font-display text-xl font-bold text-onego-navy">Sales by product</h3>
                <div className="mt-4 h-72">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={summary?.by_product || []}>
                            <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
                            <XAxis dataKey="code" stroke="#94a3b8" />
                            <YAxis stroke="#94a3b8" />
                            <Tooltip />
                            <Bar dataKey="amount" radius={[8, 8, 0, 0]}>
                                {(summary?.by_product || []).map((_, i) => (
                                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
